import { useMutation } from '@tanstack/vue-query'

export default () => {
  const authStore = useAuthStore()
  return useMutation({
    mutationFn: async ({ agentEmail, subject, message }: { agentEmail: string; subject: string; message: string }) =>
      await $fetch<string>(`/api/user/${authStore.user!.id}/agent-message`, {
        method: 'POST',
        body: JSON.stringify({ agentEmail, subject, message }),
        headers: {
          Authorization: `Bearer ${authStore.token}`,
        },
      }),
    onSuccess: () => {},
  })
}
